import { combineReducers } from "redux";
import theme from "./theme/themeSlice";
import auth from "./auth";
import base from "./base";
import patient from "./patientInfo";
import favicon from "./favicon";
import logo from "./logo";
const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    base,
    patient,
    favicon,
    logo,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
